import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './BasketDeliveryInfo.module.scss';

const BasketDeliveryInfo: React.FC = () => {
  const { t } = useTranslation();
  const delivery = undefined;
  const fetchingDelivery = false;
  return (
    <div
      className={cn(styles.deliveryInfo, {
        [styles.loading]: fetchingDelivery,
      })}
    >
      <div>{t('txt_delivery_to')} United Kindom</div>
      <hr />
      <div className={styles.deliveryRow}>
        <div>Standart</div>
        <div>$2.30</div>
      </div>
      <div className={styles.deliveryDates}>
        {t('txt_delivery_between_dates', {
          from: 'Fri 16 Aug',
          to: 'Thu 17 Aug',
        })}
      </div>
      <div className={styles.deliveryRow}>
        <div>Express</div>
        <div>$2.30</div>
      </div>
      <div className={styles.deliveryDates}>
        {t('txt_delivery_between_dates', {
          from: 'Fri 16 Aug',
          to: 'Thu 17 Aug',
        })}
      </div>
      <div>{t('txt_see_more_delivery_info')}</div>
    </div>
  );
};

export default BasketDeliveryInfo;
